import { render, staticRenderFns } from "./VMCHeaderCMS.vue?vue&type=template&id=0588dd78&scoped=true"
import script from "./VMCHeaderCMS.vue?vue&type=script&lang=js"
export * from "./VMCHeaderCMS.vue?vue&type=script&lang=js"
import style0 from "./VMCHeaderCMS.vue?vue&type=style&index=0&id=0588dd78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588dd78",
  null
  
)

export default component.exports